<style>
.form-select {
  padding-top: 5px;
  padding-bottom: 5px;
}
.vertical-center {
  margin: 0;
  position: absolute;
  top: 50%;
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
}
</style>
<script>
import appConfig from '@src/app.config'
import { tableAction } from '@utils/mixins'
import Layout from '@layouts/main'
import PageHeader from '@components/page-header'
import DailiDrilling from '@components/form/approval/approval-daily-drilling'
import DrillingActivity from '@components/form/approval/drilling-activity'
import { fieldMethods, authComputed } from '@state/helpers'

/**
 * Approval form component
 */
export default {
  page: {
    title: 'Approval Form',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: { Layout, PageHeader, DailiDrilling, DrillingActivity },
  mixins: [tableAction],
  data() {
    return {
      ...DailiDrilling.data,
      title: this.$store.state.auth.currentWell.well_name,
      comboFieldOption: [],
      comboPadOption: [],
      comboWellOption: [],
      selectedField: null,
      selectedPad: null,
      selectedWell: null,
      wellSelected: null,
      totRows: 0,
      ddrNeedApprovedItems: 0,
      activityNeedApprovedItems: {
        casing: 0,
        kick: 0,
        cement: 0,
        coring: 0,
        logging: 0,
        fishing: 0,
        welltest: 0,
        generalwork: 0,
      },
      totalActivityNeedApprovedItems: 0,
      items: [
        {
          text: 'Home',
          to: { name: 'home' },
        },
        {
          text: 'Form',
          to: { name: 'form' },
        },
        {
          text: 'Approval Form',
          to: { name: 'approval-form' },
        },
      ],
    }
  },
  computed: {
    ...authComputed,
  },
  watch: {},
  mounted() {
    this.$watch(
      () => this.$refs.cmpDrillingActivity.total,
      (val) => {
        this.totRows = val
      }
    )
  },
  created: function () {
    this.retrieveComboOptionField()
    this.selectedField = this.currentWell.pad.fieldId
    this.retrieveComboOptionPad(this.selectedField)
    this.selectedPad = this.currentWell.padId
    this.retrieveComboOptionWell(this.selectedPad)
    this.selectedWell = this.currentWell.wellId
  },
  methods: {
    ...fieldMethods,
    totalrowddr(val) {
      if (val > 99) {
        this.ddrNeedApprovedItems = '99+'
      } else {
        this.ddrNeedApprovedItems = val
      }
    },
    totalrowactivity(val) {
      if (val > 99) {
        this.activityNeedApprovedItems = '99+'
      } else {
        this.activityNeedApprovedItems = val
      }
    },
    retrieveComboOptionField() {
      this.comboFieldOption = []
      this.selectedField = null
      this.selectedPad = null
      this.selectedWell = null
      let opt = { value: -1, text: '-- ALL --' }
      this.comboFieldOption.push(opt)
      this.getFields({ params: {} }).then((resp) => {
        resp.data.data.forEach((item) => {
          let opt = { value: item.fieldId, text: item.fieldName }
          this.comboFieldOption.push(opt)
        })
      })
    },
    retrieveComboOptionPad(fieldId) {
      this.comboPadOption = []
      this.comboWellOption = []
      this.selectedPad = null
      this.selectedWell = null
      let opt = { value: -1, text: '-- ALL --' }
      this.comboPadOption.push(opt)
      this.getPads({ params: { fieldId: fieldId } }).then((resp) => {
        resp.data.data.forEach((item) => {
          let opt = { value: item.padId, text: item.padName }
          this.comboPadOption.push(opt)
        })
      })
    },
    retrieveComboOptionWell(padId) {
      this.comboWellOption = []
      this.selectedWell = null
      let opt = { value: -1, text: '-- ALL --' }
      this.comboWellOption.push(opt)
      this.getWells({
        params: { fieldId: this.selectedField, padId: padId },
      }).then((resp) => {
        resp.data.data.forEach((item) => {
          let opt = { value: item.wellId, text: item.wellName }
          this.comboWellOption.push(opt)
        })
      })
    },
    fieldChangedEvent(fieldId) {
      this.retrieveComboOptionPad(fieldId)
      this.selectedPad = -1
      this.retrieveComboOptionWell(this.selectedPad)
      this.selectedWell = -1
    },
    padChangedEvent(padId) {
      this.retrieveComboOptionWell(padId)
      this.selectedWell = -1
    },
    wellChangedEvent(wellId) {
      this.selectedWell = wellId
    },
  },
}
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-12">
        <div class="card-box">
          <h4>Report Approval</h4>
          Approve some submitted report.
          <hr />
          <b-row class="form-select">
            <b-col cols="1"><span class="vertical-center">Field:</span></b-col>
            <b-col cols="3">
              <b-form-select
                v-model="selectedField"
                :options="comboFieldOption"
                @change="fieldChangedEvent"
              ></b-form-select>
            </b-col>
          </b-row>
          <b-row class="form-select">
            <b-col cols="1"><span class="vertical-center">Pad:</span></b-col>
            <b-col cols="3">
              <b-form-select
                v-model="selectedPad"
                :options="comboPadOption"
                @change="padChangedEvent"
              ></b-form-select>
            </b-col>
          </b-row>
          <b-row class="form-select" style="padding-bottom: 20px">
            <b-col cols="1"><span class="vertical-center">Well:</span></b-col>
            <b-col cols="3">
              <b-form-select
                v-model="selectedWell"
                :options="comboWellOption"
                @change="wellChangedEvent"
              ></b-form-select>
            </b-col>
          </b-row>
          <div class="row">
            <div class="col-12">
              <div>
                <b-tabs>
                  <b-tab active>
                    <template v-slot:title>
                      Daily Drilling Report &nbsp;&nbsp;<b-badge
                        v-if="ddrNeedApprovedItems > 0"
                        variant="danger"
                        >{{ ddrNeedApprovedItems }}</b-badge
                      >
                    </template>
                    <DailiDrilling
                      :well-id="selectedWell"
                      :pad-id="selectedPad"
                      :field-id="selectedField"
                      :total-row-ddr="totalrowddr"
                      ref="DailyDrillingReport"
                    />
                  </b-tab>
                  <b-tab>
                    <template v-slot:title>
                      Drilling Activity &nbsp;&nbsp;<b-badge
                        v-if="totRows > 0"
                        variant="danger"
                        >{{ totRows }}</b-badge
                      >
                    </template>
                    <DrillingActivity
                      ref="cmpDrillingActivity"
                      :well-id="selectedWell"
                      :pad-id="selectedPad"
                      :field-id="selectedField"
                      :total-row-ddr="totalrowactivity"
                    />
                  </b-tab>
                  <!-- <b-tab title="Subsurface" disabled lazy ><p>Subsurface</p></b-tab> -->
                </b-tabs>
              </div>
            </div>
            <!-- end col -->
          </div>
          <!-- end row -->
        </div>
        <!-- end card-box -->
      </div>
      <!-- end col -->
    </div>
    <!-- end row -->
  </Layout>
</template>